<template>
    <RequestList></RequestList>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const RequestList = defineAsyncComponent(() =>
    import("../../components/Logistics/RequestList/RequestList.vue")
);
export default {
    name: "Logistics_RequestList", //The name you are in should not equal the name of the component you are importing.
    components: { RequestList, AuthLayout },
};
</script>
